import axiosInstance from "../../axios/axiosInstance";
import { CREATE_SIZE_CHART, GET_SIZE_CHART } from "../../constants";

// Get size types and sizes for a subsubcategory (or subcategory)
export const getSizeTypesAndSizes = ([subsubcategoryId]) => onResponse => {
    try {
        
        axiosInstance.get(`/sizechart/sizes-types?subsubcategoryIds=${subsubcategoryId}`)
            .then((response) => {
                onResponse(response);
                console.log("Size Types and Sizes Data:", response.data);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // Optionally handle error
    }
};

export const createSizeChart = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_SIZE_CHART, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // Optionally handle error
    }
}

// Get size chart.
export const getSizeChart = (props) => onResponse => {
    try {
        axiosInstance.get(GET_SIZE_CHART, { params: props })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // Optionally handle error
    }
}